import React from 'react';

interface StatusBadgeProps {
  status?: string;
  className?: string;
  variant?: 'admin' | 'dashboard' | 'auto';
}

/**
 * Unified StatusBadge component
 * Supports both admin and dashboard status types
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  className = '', 
  variant = 'auto' 
}) => {
  const getStatusConfig = (status?: string, variant?: string) => {
    // Normalize status to lowercase for comparison
    const normalizedStatus = status?.toLowerCase();
    
    // Common statuses
    switch (normalizedStatus) {
      case "approved":
        return {
          text: "Approved",
          className: "bg-green-100 text-green-800"
        };
      case "rejected":
        return {
          text: "Rejected", 
          className: "bg-red-100 text-red-800"
        };
      case "pending":
        return {
          text: "Pending",
          className: "bg-yellow-100 text-yellow-800"
        };
      
      // Dashboard-specific statuses
      case "completed":
        return {
          text: "Completed",
          className: "bg-blue-100 text-blue-800"
        };
      case "processing":
        return {
          text: "Processing",
          className: "bg-purple-100 text-purple-800"
        };
      case "failed":
        return {
          text: "Failed",
          className: "bg-red-100 text-red-800"
        };
      case "uploading":
        return {
          text: "Uploading",
          className: "bg-orange-100 text-orange-800"
        };
      case "queued":
        return {
          text: "Queued",
          className: "bg-gray-100 text-gray-800"
        };
      
      // Admin-specific statuses (if any future ones are added)
      case "review":
        return {
          text: "Under Review",
          className: "bg-blue-100 text-blue-800"
        };
      
      default:
        // Default based on variant
        if (variant === 'admin') {
          return {
            text: "Pending",
            className: "bg-yellow-100 text-yellow-800"
          };
        }
        return {
          text: "Pending",
          className: "bg-yellow-100 text-yellow-800"
        };
    }
  };

  const config = getStatusConfig(status, variant);
  
  return (
    <span 
      className={`flex items-center justify-center ${config.className} ${className}`}
      style={{
        borderRadius: '30px',
        paddingTop: '5px',
        paddingRight: '13px',
        paddingBottom: '5px',
        paddingLeft: '13px',
        height: '30px',
        width: '90px',
        fontFamily: 'Maven Pro',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
        letterSpacing: '0%'
      }}
    >
      {config.text}
    </span>
  );
};

export default StatusBadge;
